<template>
  <div
    class="bg-background-info-primary/20 flex space-x-2 rounded-2xl bg-opacity-20 p-4"
  >
    <img
      class="h-6 w-6"
      src="./assets/gray-warning.svg"
      width="24"
      height="24"
      alt=""
      role="presentation"
    />
    <p class="text-text-neutral-primary text-sm font-medium">
      {{ t('roamingDevices.warning') }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
</script>

<i18n src="../locales.json" />
